import { render, staticRenderFns } from "./GraficPie.vue?vue&type=template&id=34ad6986&scoped=true"
import script from "./GraficPie.vue?vue&type=script&lang=js"
export * from "./GraficPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ad6986",
  null
  
)

export default component.exports